const getDeleteModalTitleKey = (isSiteFilesEntry, itemsCount) => {
  if (itemsCount === 0) {
    return 'files-manager.empty-trash-modal-warning.title';
  }
  if (isSiteFilesEntry) {
    return 'files-manager.storage-manager.delete-permanently-modal-warning.title';
  }
  return 'files-manager.delete-permanently-modal-warning.title';
};
export const getDeleteModalTitle = (formatMessage, isSiteFilesEntry, itemsCount) => {
  return formatMessage({
    id: getDeleteModalTitleKey(isSiteFilesEntry, itemsCount)
  }, {
    itemsCount
  });
};
//# sourceMappingURL=getDeleteModalTitle.js.map